export default {
  // Hero Section
  'hero.title.invest': 'Investment - Residency',
  'hero.title.card': 'Get European Temporary Residence Card',
  'hero.description': 'Invest in Asian Alley supermarket - Get Latvia temporary residence card in 4-6 months for the whole family',
  'hero.cta.consult': 'Register Free Consultation',
  'hero.cta.learnMore': 'Learn More',
  'hero.stat1.title': '4-6 Months',
  'hero.stat1.desc': 'Fast application processing time',
  'hero.stat2.title': 'Whole Family',
  'hero.stat2.desc': 'Spouse and children under 18',
  'hero.stat3.title': 'Safe',
  'hero.stat3.desc': 'Proven business model',

  // Benefits Section
  'benefits.title': 'Outstanding Benefits',
  'benefits.description': 'Latvia residency brings you and your family comprehensive development opportunities',
  'benefits.1.title': 'European Residence Card',
  'benefits.1.desc': 'Get Latvia residence card, free travel in 26 Schengen countries',
  'benefits.2.title': 'Quality Education',
  'benefits.2.desc': 'Children access advanced European education system with free tuition upon residency',
  'benefits.3.title': 'Modern Healthcare',
  'benefits.3.desc': 'Enjoy European healthcare system with reasonable costs and high service quality',
  'benefits.4.title': 'Safety & Stability',
  'benefits.4.desc': 'Latvia is an EU and NATO member country with a safe and stable living environment',
  'benefits.5.title': 'Safe Residency',
  'benefits.5.desc': 'Proven business model, ensuring safe card for family throughout 5 years of residency',
  'benefits.6.title': 'Work Opportunities',
  'benefits.6.desc': 'Join work directly at Asian Alley stores in the system',

  // Process Section
  'process.title': 'Implementation Process',
  'process.description': '6 simple steps to complete Latvia residency application in 4-6 months',
  'process.step1.title': 'Consultation & Assessment',
  'process.step1.desc': 'Our experts will provide detailed consultation about the program and assess your profile',
  'process.step2.title': 'Document Preparation',
  'process.step2.desc': 'Support preparing complete legal documents and necessary papers as required',
  'process.step3.title': 'Investment Contract Signing',
  'process.step3.desc': 'Sign investment contract with Asian Alley supermarket with clear, transparent terms',
  'process.step4.title': 'Application Submission',
  'process.step4.desc': 'Submit residence card application to Latvia immigration authority',
  'process.step5.title': 'Interview & Review',
  'process.step5.desc': 'Support interview preparation and track application review process',
  'process.step6.title': 'Receive Residence Card',
  'process.step6.desc': 'Receive Latvia temporary residence card for the whole family',
  'process.note': 'Processing time:',
  'process.noteTime': '4-6 months from complete application submission',

  // Packages Section
  'packages.badge': 'Transparent costs',
  'packages.title': 'Residency Costs',
  'packages.description': 'Overview of Latvia residency costs — transparent, clear, no hidden fees',
  'packages.common.title': 'Common Costs',
  'packages.excluded.title': 'Not Included',
  'packages.cost1.label': 'Investment value',
  'packages.cost1.amount': '50,000 EUR',
  'packages.cost2.label': 'Government Tax',
  'packages.cost2.amount': '10,000 EUR',
  'packages.excluded1': 'Flight tickets',
  'packages.excluded2': 'VISA costs',
  'packages.excluded3': 'Other costs arising during procedures but not included in contract',
  'packages.note': 'Commitment to transparent costs — No additional charges beyond contract',

  // FAQ Section
  'faq.title': 'Frequently Asked Questions',
  'faq.description': 'Answers to common questions about Latvia residency program',
  'faq.q1': 'Why choose Latvia residency?',
  'faq.a1': 'Latvia is a member of the European Union (EU) and Schengen area. With Latvia residence card, you will receive: Free travel in 29 Schengen countries. Legal residence rights in Europe. Opportunity for children to study in EU at low cost. Opportunity to expand business in European market. Low investment cost compared to other EU residency programs.',
  'faq.q2': 'Will the 50,000 EUR investment be lost?',
  'faq.a2': 'The 50,000 EUR is participation in the program to qualify for Latvia temporary residence card according to government regulations. The main goal is to help you and your family receive legal residence rights in Europe. After minimum 5 years maintenance, depending on activity situation and program conditions at that time, you may receive back about 10,000 – 15,000 EUR. The remaining cost is considered program participation and residence condition maintenance cost, similar to other residency programs in Europe.',
  'faq.q3': 'How long until I receive the residence card?',
  'faq.a3': 'Typically processing time: 6 – 12 months from complete documents and investment. With VIP package, application is prioritized for faster processing.',
  'faq.q4': 'Do I need to live in Latvia?',
  'faq.a4': 'Not required to live full-time in Latvia. You can still: Live in Vietnam, Travel to Europe when needed, Maintain legal residence card. The program is very suitable for: Business owners; Investors; People who want "backup European residence rights".',
  'faq.q5': 'Can my family come along?',
  'faq.a5': 'Yes. The program allows including: Spouse, Dependent children. The whole family receives Latvia residence card at the same time.',
  'faq.q6': 'What do I receive after Latvia residency?',
  'faq.a6': 'You will receive: Latvia residence card, Right to live in Europe, Free Schengen travel, Opportunity for children to study in EU, Foundation to expand international business. This is an important stepping stone to become European citizen in the future.',
  'faq.q7': 'Does the company support employment when I come to Latvia?',
  'faq.a7': 'After coming to Latvia, depending on ability, the company will support job introduction at companies/enterprises or work directly at Asian Alley supermarket.',
  'faq.q8': 'Why do it now?',
  'faq.a8': 'EU residency programs usually: Increase costs over time; Change policies; Tighten conditions. Currently, Latvia is still a program: Low cost; Simple conditions; High success rate. Doing early will save costs and ensure opportunities.',
  'faq.q9': 'Why does the program choose to invest in Asian Alley?',
  'faq.a9': 'Asian Alley is an Asian supermarket owned by Vietnamese in Latvia, has been operating for many years with stable business foundation. 1. Business owner is Vietnamese – easy support, Understand needs and psychology of Vietnamese customers, Easy to communicate, support and handle when needed. 2. Business is actually operating and stable. Supermarket is doing real business, not a company opened just for applications. Has stable customer base in Latvia. Has clear operating history. This ensures the program is legal and safe. 3. Ensures Latvia residence card conditions, Main goal of investment: Meet program residence conditions, Help customers receive legal Latvia temporary residence card, Maintain card for long term. Asian Alley fully meets these legal conditions.',

  // Stats Section
  'stats.title': 'Impressive Numbers',
  'stats.description': 'Our proud achievements in Latvia residency field',
  'stats.1.number': '500+',
  'stats.1.label': 'Trusted Customers',
  'stats.2.number': '98%',
  'stats.2.label': 'Success Rate',
  'stats.3.number': '4-6',
  'stats.3.label': 'Months Processing',
  'stats.4.number': '5+',
  'stats.4.label': 'Years Experience',
  'stats.asian.title': 'ASIAN ALLEY ASIAN SUPERMARKET IN LATVIA',
  'stats.asian.location': '2 locations in central Riga, Latvia',
  'stats.asian.revenue': 'Annual revenue',

  // CTA Section
  'cta.title': 'Start Your Residency Journey',
  'cta.description': "Don't miss the golden opportunity to own European residence card. Our expert team is ready to provide free consultation and accompany you throughout the residency journey.",
  'cta.button.consult': 'Register Free Consultation',
  'cta.button.call': 'Call Now',

  // Detail Hero Section
  'detail.hero.badge': 'Gateway to Europe',
  'detail.hero.title': 'Latvia Residency',
  'detail.hero.titleSub': '- European Residency Opportunity',
  'detail.hero.description': 'Latvia - Golden gateway to own European temporary residence card with reasonable cost and fast process. Latvia investment residency from only 50,000 EUR.',

  // Why Latvia Section
  'detail.why.title': 'Why Choose',
  'detail.why.titleBold': 'Latvia Residency',
  'detail.why.p1': 'Latvia is a member of the European Union and Schengen area, located in strategic position in Northeast Europe. With flexible residency through investment policy, Latvia is becoming an attractive destination for many Vietnamese families wanting European residency.',
  'detail.why.p2': 'Latvia investment residency program allows you and your family to receive temporary residence card in just 4-6 months through investing in local businesses like Asian Alley supermarket. Reasonable Latvia residency cost, transparent process.',
  'detail.why.stat1': 'Schengen Countries',
  'detail.why.stat2': 'Population',

  // Requirements Section
  'detail.requirements.title': 'Latvia Investment Residency',
  'detail.requirements.titleBold': 'Conditions',
  'detail.requirements.description': 'Simple and easy-to-meet requirements for most Vietnamese families wanting Latvia residency',
  'detail.requirements.1.title': 'Age',
  'detail.requirements.1.desc': 'From 18 years old and above, no maximum age limit',
  'detail.requirements.2.title': 'Clean Record',
  'detail.requirements.2.desc': 'No criminal record, clean judicial background',
  'detail.requirements.3.title': 'Financial Capacity',
  'detail.requirements.3.desc': 'Ability to invest from €50,000 and above',
  'detail.requirements.4.title': 'Complete Documents',
  'detail.requirements.4.desc': 'Prepare complete papers as required by immigration authority',

  // Asian Alley Invest Section
  'detail.asian.title': 'Invest in Asian Alley',
  'detail.asian.titleSub': '- Path to Latvia Residency',
  'detail.asian.description': 'Asian Alley is the leading Asian supermarket chain in Latvia with 2 locations in central Riga. The supermarket specializes in providing high-quality Asian food and goods, serving the growing Asian community in Latvia.',
  'detail.asian.location.label': 'Location:',
  'detail.asian.location.value': '2 locations in central Riga, Latvia',
  'detail.asian.revenue.label': 'Revenue:',
  'detail.asian.revenue.value': 'Over €500,000/year and growing',
  'detail.asian.customers.label': 'Customers:',
  'detail.asian.customers.value': 'Serving thousands of customers monthly',
  'detail.asian.button': 'Learn Details',

  // Benefits Detail Section
  'detail.benefits.title': 'Latvia Temporary Residence Card',
  'detail.benefits.titleSub': 'Rights',
  'detail.benefits.description': 'Practical benefits when owning Latvia temporary residence card and European residency',
  'detail.benefits.1': 'Free travel in 26 Schengen countries',
  'detail.benefits.2': 'Right to reside and work in Latvia',
  'detail.benefits.3': 'Children study for free',
  'detail.benefits.4': 'Enjoy European healthcare system',
  'detail.benefits.5': 'After 10 years can apply for Latvia citizenship',
  'detail.benefits.6': 'Safe, civilized living environment',
  'detail.benefits.7': 'Reasonable living costs',
  'detail.benefits.8': 'Expanding Vietnamese community',
  'detail.benefits.button': 'Register Free Consultation',

  // Investment Usage Section
  'detail.usage.title': 'What Do We Do With Your',
  'detail.usage.titleBold': 'Latvia Investment Residency',
  'detail.usage.titleEnd': 'Investment?',
  'detail.usage.description': 'Your investment is used transparently and effectively to develop Asian Alley system',
  'detail.usage.1.title': 'Expand Supermarket',
  'detail.usage.1.desc': 'Invest in expanding Asian Alley supermarket chain in Latvia and Baltic region, increasing number of locations and business scale',
  'detail.usage.2.title': 'Expand Products',
  'detail.usage.2.desc': 'Diversify high-quality Asian product portfolio, meeting growing community demand',
  'detail.usage.3.title': 'Upgrade Logistics',
  'detail.usage.3.desc': 'Invest in modern warehouse, transportation and supply chain management system, ensuring goods are always fresh',
  'detail.usage.4.title': 'Develop Personnel',
  'detail.usage.4.desc': 'Recruit and train professional staff team, creating job opportunities for Vietnamese community in Latvia',
  'detail.usage.commitment.title': 'Transparency Commitment',
  'detail.usage.commitment.desc': 'All investments are used for actual business development purposes of Asian Alley. We commit to transparency in operations and capital use, ensuring rights for Latvia residency investors.',

  // Blog Preview Section
  'detail.blog.title': 'News & Guide',
  'detail.blog.titleBold': 'Latvia Residency',
  'detail.blog.description': 'Latest updates on residency policies and experience',
  'detail.blog.viewAll': 'View all',
  'detail.blog.viewAllMobile': 'View all articles',

  // Page Meta
  'meta.latvia.title': 'Latvia Residency 2025 - Conditions, Process & Investment Cost | The Daeg International',
  'meta.latvia.description': 'Detailed guide on Latvia residency 2025: Investment conditions from 50,000 EUR, 4-6 months process, Schengen temporary residence card rights. Invest in Asian Alley - leading Asian supermarket chain in Riga, Latvia. Free consultation for Vietnamese.',
  'meta.latvia.keywords': 'Latvia residency 2025, Latvia residency conditions, Latvia residency cost, Latvia residency process, Asian Alley investment, Schengen temporary residence card, Riga residency, Latvia residency rights, European immigration',
  'meta.detail.title': 'Latvia Residency Details - Conditions, Rights & Investment | The Daeg International',
  'meta.detail.description': 'Detailed information about Latvia residency: Why choose Latvia, investment conditions from 50,000 EUR, Schengen temporary residence card rights, invest in Asian Alley. Free consultation for Vietnamese.',
  'meta.detail.keywords': 'Latvia residency details, Latvia residency conditions, temporary residence card rights, Asian Alley investment, European residency, Schengen card',
};